import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-imprimir-carga-cobranzas',
  templateUrl: './imprimir-carga-cobranzas.component.html',
  styleUrls: ['./imprimir-carga-cobranzas.component.scss']
})
export class ImprimirCargaCobranzasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
